module.exports = __webpack_public_path__ + "img/task-remove.2ea4caf0.svg";